<div class="logo">
  <a id="corp_logo" href="/" class="simple-text">
    <div class="logo-img">
      <img [src]="companyImageUrl" alt="Company Logo"/>
    </div>
    PlanaCan
  </a>
  <button type="button" class="pc-collapse-toggle" (click)="toggleCollapse()"
          [attr.aria-label]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
          [attr.aria-pressed]="collapsed" data-testid="sidebar-collapse-toggle">
    <i class="material-icons">chevron_left</i>
  </button>
  <app-company-view-and-dropdown></app-company-view-and-dropdown>
</div>
<div class="sidebar-wrapper">
  @if (isMobileMenu()) {
    <div>
      <ul class="nav navbar-nav nav-mobile-menu">
        <!-- <li class="nav-item">
        <a class="nav-link" href="#pablo">
          <i class="material-icons">dashboard</i>
          <p>
            <span class="d-lg-none d-md-block">Stats</span>
          </p>
        </a>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link" href="#pablo" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="material-icons">notifications</i>
          <span class="notification">5</span>
          <p>
            <span class="d-lg-none d-md-block">Some Actions</span>
          </p>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item" href="#">Mike John responded to your email</a>
          <a class="dropdown-item" href="#">You have 5 new tasks</a>
          <a class="dropdown-item" href="#">You're now friend with Andrew</a>
          <a class="dropdown-item" href="#">Another Notification</a>
          <a class="dropdown-item" href="#">Another One</a>
        </div>
      </li> -->
      <!-- <li>
      <button class="upgrade-fab" mat-fab color="primary" (click)="docs()">
        <span class="extended-fab-button__text">Documentation</span>
      </button>
    </li> -->
    <li>
      <button class="upgrade-fab" mat-fab color="warn" (click)="askQuestion()">
        <span class="extended-fab-button__text">Questions?</span>
      </button>
    </li>
    <li class="text-center mt-2">
      <a class="nav-item userprofile" routerLink="/console/profile">{{ user?.displayName }}</a>
    </li>
    <li class="nav-item dropdown">
      <a class="nav-link" href="javascript:void(0)" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="material-icons">settings</i>
        <p>
          <span matBadge="0" [matBadgeHidden]="!showReleaseNotification" class="d-lg-none d-md-block hide-text">Settings</span>
        </p>
      </a>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
        @if (canSelectOtherCompany) {
          <a class="dropdown-item" routerLink="/company-select">Select other Company</a>
        }
        @if (canSeeCompanyManagement) {
          <a class="dropdown-item" routerLink="/console/company-settings">Edit Company Settings</a>
        }
        <a class="dropdown-item" routerLink="/console/processes">Processes</a>
        <a class="dropdown-item" href="https://planacan.io/release-notes/" target="_blank">Release Notes @if (showReleaseNotification) {
          <span class="new-flag">{{version}}</span>
        }</a>
      </div>
    </li>
  </ul>
</div>
}
<ul class="nav">
  @for (menuItem of menuItems; track menuItem) {
    <li routerLinkActive="active" class="{{menuItem.class}} nav-item">
      <a [id]="menuItem.id" class="nav-link" [routerLink]="[menuItem.path]" [attr.title]="collapsed ? menuItem.title : null">
        <i class="material-icons">{{menuItem.icon}}</i>
        <p>{{menuItem.title}}</p>
      </a>
      @if (menuItem.children && menuItem.children.length > 0) {
        <ul class="nav sub-menu" [ngStyle]="{ 'display': isMenuOrChildActive(menuItem) ? 'block' : 'none' }">
          @for (childMenu of menuItem.children; track childMenu) {
            <li routerLinkActive="active" class="{{childMenu.class}} nav-item sub-item">
              @if (canSeeSensor || childMenu.id != 'menu_sensors') {
                <a [id]="childMenu.id" class="nav-link" [routerLink]="[childMenu.path]">
                  <i class="material-icons">{{childMenu.icon}}</i>
                  <p>{{childMenu.title}}</p>
                </a>
              }
            </li>
          }
        </ul>
      }
    </li>
  }
  <!-- <li class="active-pro nav-item">
    <a class="action-sidebar-btn nav-link" href="https://planacan.io/referrals/">
      <i class="material-icons">forward_to_inbox</i>
      <p>Refer a Friend - Earn $500</p>
    </a>
  </li> -->
</ul>
</div>
